import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getInvestorApiUrl } from "../../utils/config"; // Assuming this function provides the base URL.
import { ApiRequestParams, handleFetchApi } from "../../utils/api";

interface initialState {
  favoriteProperties: any,
  loading: boolean,
  error: any,
  selectedIds: any,
  isAdding:boolean
};
const initialState: initialState = {
  favoriteProperties: [],
  loading: false,
  error: null,
  selectedIds: [],
  isAdding:false,
};
// Thunk to add property to favorites
export const addFavoriteProperty = createAsyncThunk(
  "favoriteproperty/addFavoriteProperty",
  async (requiredData: any, { rejectWithValue }) => {
    try {

      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `investor/favouriteProperty?investorId=${requiredData.investorId}&propertyId=${requiredData.propertyId}&isRemoved=${requiredData.isRemoved}`,
        method: "POST"
      }
      const response = await handleFetchApi(params);

      // const response = await axios.post(
      //   `${baseUrl}/investor/favouriteProperty?investorId=${requiredData.investorId}&propertyId=${requiredData.propertyId}&isRemoved=${requiredData.isRemoved}`
      // );
      return response.data; // Returns the added/removed property
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to get favorite properties
export const getFavorityProperty = createAsyncThunk(
  "favoriteproperty/getFavorityProperty",
  async (investorId, { rejectWithValue }) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `investor/favouriteProperty?investorId=${investorId}`,
      }
      const response = await handleFetchApi(params);
      // const response = await axios.get(
      //   `${baseUrl}/investor/favouriteProperty?investorId=${investorId}`
      // );
      const favIds = response.data.data.map((item: any) => (item.propertyId));
      return [response.data.data, favIds]; // Assuming response contains a "data" field with the properties
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice to manage favorite properties
const favoritePropertySlice = createSlice({
  name: "favoriteproperty",
  initialState,
  reducers: {
    addSelectedId: (state: any, action: PayloadAction<any>) => {
      state.selectedIds = [...state.selectedIds, action.payload]
    },
    removeSelectedId: (state: any, action: PayloadAction<any>) => {
      const filteredIds = [...state.selectedIds].filter((item) => item !== action.payload)
      state.selectedIds = [...filteredIds]
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addFavoriteProperty.pending, (state) => {
        state.isAdding = true;
        state.error = null;
      })
      .addCase(getFavorityProperty.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addFavoriteProperty.fulfilled, (state, action) => {
        state.isAdding = false;
      })
      .addCase(getFavorityProperty.fulfilled, (state, action) => {
        state.loading = false;
        state.favoriteProperties = action.payload[0]; // The list of favorite properties
        state.selectedIds = [...action.payload[1]]
      })
      .addCase(addFavoriteProperty.rejected, (state, action: any) => {
        state.isAdding = false;
        state.error = action.payload;
      })
      .addCase(getFavorityProperty.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addSelectedId, removeSelectedId } = favoritePropertySlice.actions;
export default favoritePropertySlice.reducer;
